import { Component, OnInit } from '@angular/core';
import { RoleMaster } from '../../models/rolemaster';
import { PageHeader } from 'src/app/utils/models/page-header';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage } from '@gbs-platform-client/fwk-core';
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { RoleMasterService } from '../../services/role';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';

@Component({
  selector: 'app-rolemaster',
  templateUrl: './rolemaster.component.html',
  styleUrls: ['./rolemaster.component.css']
})
export class RolemasterComponent implements OnInit {
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerEntity: PageHeader;
  entity: RoleMaster = new RoleMaster();
  selectedrole: RoleMaster = new RoleMaster();
  editingEntity: RoleMaster = new RoleMaster();
  role: Array<RoleMaster>;
  entityColumns: any[];
  listView: boolean = true;
  formCaption: string = '';

  constructor(
    private _RoleMasterService: RoleMasterService,
    private _coreSaveService: CoreSaveService,
    private messageService: MessageService,
    private notification: NotificationsService,

  ) {

    {
      this.headerEntity = this.initPageHeader();
      this.entityColumns = [
        //{ field:"Role_Id", title: 'Id' },
        { field: "Role_Name", title: 'Role', filter: true, sortable: true },
        // { field:"Status_Id", title: 'Status' }
      ];
      this.role = [];
      this.getAllRoles();

    }
  }
  getAllRoles() {
    this._RoleMasterService.getAllRoles().subscribe((role: Array<RoleMaster>) => {
      this.role = role;
    });
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._RoleMasterService.deleteRole(this.selectedrole.Role_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearRole();
            this.getAllRoles();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerEntity = new PageHeader();
    headerEntity.PageCaption = "ROLE";
    headerEntity.IconClass = "bi bi-person-rolodex";
    return headerEntity;
  }
  deleteRole(event: any) {
    if (event.seletedRows[0]) {
      this.selectedrole.Role_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this Role ?",
          caption: "Role",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }
  addRole(event: any) {
    this.listView = false;
    this.clearRole();
    this.formCaption = "ROLE";
  }
  editRole(event: any): void {
    if (event.seletedRows[0]) {
      let editRole = this.role.find(x => x.Role_Id === event.seletedRows[0]);
      if (editRole) {
        this.editingEntity = editRole;
        this.entity = { ...this.editingEntity };
        this.listView = false;
        this.formCaption = "Edit Role";
      }
    }
  }
  saveRole(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._RoleMasterService.checkDuplication(this.entity.Role_Name, this.entity.Role_Id).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Role already exists');
        }
        else {

          this._RoleMasterService.saveRole(this.entity).subscribe(() => {
            if (this.entity.Role_Id == 0) {
              this.notification.showSuccess('Saved Successfully');
            }
            else {
              this.notification.showSuccess('Updated Successfully');
            }
            this.listView = true;
            this.clearRole();
            this.getAllRoles();
          })
        }
      });
    }
  }

  gotoBack(): void {
    this.listView = true;
  }
  refreshRole(event: any): void {
    this.role = [];
    this.getAllRoles();
  }
  clearRole(): void {
    this.entity = new RoleMaster();
  }
  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}



